import * as go from 'gojs';
import { withoutUndoManager } from '../../../../../utils/without-undo-manager';
import { registerNodeTemplate } from '../../common/utils/registerNodeTemplate';
import { PinNodeTemplateProps } from '../models/pin-node-template-props';
import { pinNodeTemplate } from '../pin-node';
import { calculatePinScale } from '../utils/calculate-pin-scale';

export const setupPinNode = (diagram: go.Diagram, categoryName: string, templateProps: PinNodeTemplateProps) => {
  registerNodeTemplate(diagram, categoryName, pinNodeTemplate(templateProps));
  return registerDiagramListeners(diagram, categoryName, templateProps);
};

const registerDiagramListeners = (diagram: go.Diagram, categoryName: string, templateProps: PinNodeTemplateProps) => {
  const onViewportBoundsChanged = updatePinsScale(categoryName);
  const onSelectionChanged = customSelectionAction(categoryName, templateProps);

  diagram.addDiagramListener('ViewportBoundsChanged', onViewportBoundsChanged);
  diagram.addDiagramListener('ChangedSelection', onSelectionChanged);

  return () => {
    diagram.removeDiagramListener('ViewportBoundsChanged', onViewportBoundsChanged);
    diagram.removeDiagramListener('ChangedSelection', onSelectionChanged);
  };
};

const updatePinsScale = (categoryName: string) => (e: go.DiagramEvent) =>
  withoutUndoManager(e.diagram, () =>
    e.diagram.nodes.filter((x) => x.category === categoryName).each((x) => (x.scale = calculatePinScale(e.diagram))),
  );

const customSelectionAction =
  (categoryName: string, { onSelect, onUnselect }: PinNodeTemplateProps) =>
  (e: go.DiagramEvent) =>
    e.diagram.selection.first()?.category === categoryName ? onSelect() : onUnselect();
